export const DIMENSIONS_ATTRIBUTES = ['x', 'y', 'width', 'height'];

function isValidDimension (fromDimensions, targetDimensions) {
  const isSameWidth = fromDimensions.width === targetDimensions.width;
  const isSameHeight = fromDimensions.height === targetDimensions.height;
  const isSameSize = isSameWidth && isSameHeight;
  const isInvalidSize = !fromDimensions.width && !fromDimensions.height;

  return !(isSameSize || isInvalidSize);
}

function applyDimensionFrom (mode) {
  const getDimensions = mode === 'bbox'
    ? getDimensionsFromElement
    : getDimensionsFromBoxCoordinates;

  return ({ from, to: target }) => {
    const [fromDimensions, targetDimensions] = [from, target].map(getDimensions);
    if (!isValidDimension(fromDimensions, targetDimensions)) return;

    svgedit.utilities.assignAttributes(target, fromDimensions);
  }
}

export function getBoxCoordinatesFromDimensions (dimensions) {
  return DIMENSIONS_ATTRIBUTES
    .map(attribute => dimensions[attribute])
    .join(' ');
}

export const applyDimensionsFromElement = applyDimensionFrom('bbox');
export const applyDimensionsFromBoxCoordinates = applyDimensionFrom('boxCoordinates');

export function getDimensionsFromElement (element) {
  const defaultBBox = {};
  DIMENSIONS_ATTRIBUTES.forEach(attribute => {
    defaultBBox[attribute] = 0;
  });
  const elementReference = element.getBBox?.() ?? defaultBBox;

  return DIMENSIONS_ATTRIBUTES.reduce((result, attribute) => ({
    ...result,
    [attribute]: getAttribute(attribute)
  }), {});

  function getAttribute (attribute) {
    return Number(element.getAttribute(attribute)) || elementReference[attribute];
  }
}

export function getDimensionsFromBoxCoordinates (element) {
  const boxCoordinates = element.dataset.boxCoordinates ?? element.textContent;
  const regexWhitespace = /\s+/;
  const attributes = boxCoordinates.split(regexWhitespace).map(Number);

  if (attributes.length !== 4) return getDimensionsFromElement(element);

  return DIMENSIONS_ATTRIBUTES.reduce((result, attribute, index) => ({
    ...result,
    [attribute]: attributes[index]
  }), {});
}

export function getDimensionsFromAttributes (element) {
  return DIMENSIONS_ATTRIBUTES.reduce((result, attribute) => ({
    ...result,
    [attribute]: Number(element.getAttribute(attribute))
  }), {});
}
